import { initBrowser } from './browser';

export const initMSW = async (): Promise<boolean | void> => {

    // @ts-ignore
    if (import.meta.env.VITE_IS_MSW_ENABLED !== 'true') {
        return false;
    }
    initBrowser();
}